import {
  Flex,
  Menu,
  MenuButton,
  Button,
  MenuList,
  Image,
  MenuItem,
  Box,
  Checkbox,
  Badge,
  Text,
  Portal,
} from "@chakra-ui/react";
import React from "react";
import { FaChevronDown } from "react-icons/fa6";
import { DefiTagImageMap } from "utils";

export type TCategoryDropdownProps = {
  options: string[];
  selectedOption: string | string[];
  onSelect: (option: string) => void;
  isCheckbox?: boolean;
  placeholder: string;
};

export default function CategoryDropdown({
  options,
  selectedOption,
  onSelect,
  isCheckbox = false,
  placeholder,
}: TCategoryDropdownProps) {
  return (
    <Flex alignItems="center" gap={4}>
      <Box
        pos="relative"
        borderWidth="1px"
        borderRadius={"8px"}
        borderColor={"#d3d3d3"}
        minWidth={{ base: "100px", sm: "150px" }}
      >
        <Menu closeOnSelect={isCheckbox ? false : true}>
          <MenuButton
            as={Button}
            h={{ base: "30px", lg: "30px" }}
            rightIcon={
              options.length > 1 || !options ? <FaChevronDown /> : <></>
            }
            w="100%"
            textAlign="left"
            className="menuButtonStake"
            // p={{ base: "0px", md: "0px 0px 0px 0px" }}
            _active={{
              bg: "backgroundCard",
            }}
            _hover={{
              bg: "backgroundCard",
            }}
            borderRadius="8px"
            bg="backgroundCard"
            color="textPrimary"
            fontWeight="400"
            fontSize={{ base: "12px", md: "14px" }}
          >
            <Flex
              alignItems="center"
              justify="space-between"
              flex={1}
              gap={2}
              display="block"
            >
              {!isCheckbox && (
                <Box flex={1}>
                  {selectedOption === "All" ? placeholder : placeholder}
                </Box>
              )}
              {isCheckbox && (
                <Flex
                  flex={1}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                  gap={1}
                >
                  <Text>
                    {selectedOption.length === 0 || selectedOption[0] === "All"
                      ? placeholder
                      : selectedOption[0]}
                  </Text>

                  {selectedOption[0] != "All" && selectedOption.length > 1 && (
                    <Badge
                      bgColor={"#D8F0F0"}
                      borderRadius={"10px"}
                      py={1}
                      ml={"2px"}
                      fontWeight={600}
                      fontSize={"12px"}
                    >
                      +{selectedOption.length - 1}
                    </Badge>
                  )}
                </Flex>
              )}
            </Flex>
            {/* </Flex> */}
          </MenuButton>
          <Portal>
            <MenuList
              transformOrigin="top !important"
              w={{
                base: "130px",
                sm: "100%",
              }}
              // p="8px"
              border="1px solid #AEDFCA"
              bg="backgroundCard"
              fontSize="14px"
              fontWeight="400"
            >
              {options.map((option: string) => {
                return (
                  <MenuItem
                    // {...refProp}
                    key={option}
                    id={option}
                    padding={2}
                    marginBottom={1}
                    onClick={(e) => {
                      e.preventDefault();
                      onSelect(option);
                    }}
                    bg={
                      !isCheckbox && selectedOption === option
                        ? "var(--chakra-colors-gray-100)"
                        : "backgroundCard"
                    }
                    _hover={{ bg: "var(--chakra-colors-gray-100)" }}
                  >
                    <Flex
                      justifyContent="space-between"
                      w="100%"
                      alignItems="center"
                      pl={2}
                    >
                      <Flex alignItems="center" gap="8px" flex={1}>
                        {isCheckbox ? (
                          <Box overflow="hidden" pos="relative">
                            <Checkbox
                              value={option}
                              isChecked={selectedOption.includes(option)}
                              _checked={{
                                "& .chakra-checkbox__control": {
                                  background: "#075A5A",
                                  borderColor: "#075A5A",
                                },
                              }}
                            />
                          </Box>
                        ) : (
                          option !== "All" && (
                            <Box
                              overflow="hidden"
                              pos="relative"
                              borderRadius="50%"
                            >
                              <Image
                                height={6}
                                width={6}
                                src={DefiTagImageMap[option]}
                                alt={option!}
                              />
                            </Box>
                          )
                        )}
                        <Flex
                          justify="space-between"
                          flex={1}
                          alignItems="center"
                          gap={2}
                        >
                          <Box flex={1} fontSize={14}>
                            {option}
                          </Box>
                        </Flex>
                      </Flex>
                    </Flex>
                  </MenuItem>
                );
              })}
            </MenuList>
          </Portal>
        </Menu>
      </Box>
    </Flex>
  );
}
